import { render, staticRenderFns } from "./ProductCardHero.vue?vue&type=template&id=665cc1f4"
import script from "./ProductCardHero.vue?vue&type=script&lang=js"
export * from "./ProductCardHero.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports